import Config from 'lib/Config';
import Helmet from 'react-helmet';
import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../shared/app/Button';
import './style.scss';

const NotFoundPage = (props) => {

    const goBack = () => {
        props.history.goBack();
    }

    return (
        <div className="not-found page-layout pad lg center flex-col-center-both">
            <Helmet><title>{Config.SITE_TITLE_PREFIX} - Page Not</title></Helmet>
            <h1>NOT FOUND</h1>
            <p className="pad md">You just found a route that doesn't exist.</p>
            <Button onClick={goBack} round color="blue">Go back</Button>
            <Button link="/" filled round color="blue" className="margin sm">Go home</Button>
        </div>
    );
}

export default NotFoundPage
